import React from "react";
import { brandAssets, offer } from "../data/offer";
export function SiteFooter() {
  return <footer className="border-t-4 border-tangerine bg-cream px-5 py-10 text-center" data-id="element-222" data-mp="3r7pwzw904d4i">
      <img src={brandAssets.logo} alt="Logo Petites Histoires, Grande Foi" className="mx-auto h-20 w-20 object-contain" data-id="element-223" data-mp="3mh9h85hpkfez" />
      <p className="mt-3 font-display text-lg font-extrabold leading-tight" data-id="element-224" data-mp="3hhwtlij0j4bc">
        <span className="text-royal" data-id="element-225" data-mp="3dhw492udl8pi">Petites Histoires,</span>{" "}
        <span className="text-tangerine" data-id="element-226" data-mp="38i1fp5y2ov7m">Grande Foi</span>
      </p>
      <p className="mt-1 text-xs font-semibold text-cocoa-soft" data-id="element-227" data-mp="38juoaqs8xpi9">
        © {new Date().getFullYear()} {offer.brand}. Tous droits réservés.
      </p>
    </footer>;
}